module.exports = __webpack_public_path__ + "img/banner.c4a50a92.png";